import { moveItemInArray } from '@angular/cdk/drag-drop';
import { MediaMatcher } from '@angular/cdk/layout';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewEncapsulation,
  input,
  output,
  inject,
} from '@angular/core';
import { ColumnInfo, ColumnSelectService } from '../column-select.service';

@Component({
  selector: 'app-column-select',
  templateUrl: './column-select.component.html',
  styleUrls: ['./column-select.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ColumnSelectService],
  standalone: false,
})
export class ColumnSelectComponent implements OnInit {
  private elementRef = inject(ElementRef);
  private columnSelectService = inject(ColumnSelectService);
  private changeDetectorRef = inject(ChangeDetectorRef);
  private media = inject(MediaMatcher);

  readonly columnsChange = output<string[]>();
  readonly columns = input<string[]>([]);
  readonly columnNames = input<string[]>([]);
  readonly saveName = input<string>();
  readonly icon = input<string | undefined>('view_column');
  readonly text = input<string | undefined>('Columnas');
  @Input() drag?: boolean = true;

  columnInfo: ColumnInfo[] = [];

  // Mobile query
  public mobileQuery: MediaQueryList;

  constructor() {
    this.mobileQuery = this.media.matchMedia('(max-width: 599px)');
    this.mobileQuery.addEventListener('change', () =>
      this.changeDetectorRef.detectChanges(),
    );
  }

  ngOnInit() {
    this.columnInfo = this.columns().map((currElement, index) => {
      return {
        id: currElement,
        name: this.columnNames()[index],
        hidden: false,
      };
    });
    this.columnInfo =
      this.columnSelectService.loadSavedColumnInfo(
        this.columnInfo,
        this.saveName(),
      ) || this.columnInfo;
    this.emitColumns(false);
  }

  ngAfterViewInit(): void {
    this.elementRef.nativeElement.classList += 'va-mat-button-no-input';
  }

  // CdkDragDrop<any>
  columnMenuDropped(event: any): void {
    moveItemInArray(
      this.columnInfo,
      event.item.data.columnIndex,
      event.currentIndex,
    );
    this.emitColumns(true);
  }

  toggleSelectedColumn(columnId: string) {
    const colFound = this.columnInfo.find((col) => col.id === columnId);
    if (colFound) colFound.hidden = !colFound.hidden;
    this.emitColumns(true);
  }

  private emitColumns(saveColumns: boolean) {
    // Only emit the columns on the next animation frame available
    window.requestAnimationFrame(() => {
      const columnas = this.columnInfo
        ?.filter((colInfo) => !colInfo.hidden)
        .map((colInfo) => colInfo.id);
      this.columnsChange.emit(columnas);
      if (saveColumns) {
        this.columnSelectService.saveColumnInfo(
          this.columnInfo,
          this.saveName(),
        );
      }
    });
  }
}
